import type { RecruitmentDashboardFilters, RecruitmentDashboardPayload } from '../recruitmentDashboard.types';

const apiBase =
  (import.meta as any).env?.VITE_API_URL ||
  (typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? ''
    : 'http://localhost:4000');

/**
 * Fetches aggregated recruitment dashboard JSON from the Node server.
 * Server must expose POST /api/recruitment-dashboard (see server/index.cjs).
 */
export async function fetchRecruitmentDashboard(
  filters: RecruitmentDashboardFilters,
  opts?: { secret?: string }
): Promise<RecruitmentDashboardPayload> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (opts?.secret) headers['x-dashboard-secret'] = opts.secret;

  const res = await fetch(`${apiBase}/api/recruitment-dashboard`, {
    method: 'POST',
    headers,
    body: JSON.stringify(filters),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as any).error || res.statusText || 'Dashboard request failed');
  }
  return res.json();
}
